import request from "@/utils/http"

export function getDingGroupList(appId) {
  return request.get("/dingGroup/getDingGroupList", { params: { appId } }).commonDeal()
}

export function deleteDingGroup(dingGroupId) {
  return request.get("/dingGroup/deleteDingGroup", { params: { dingGroupId } }).commonDeal()
}

export function updateDingGroup(dingGroup) {
  return request.post("/dingGroup/updateDingGroup", dingGroup)
}

export function createDingGroup(dingGroup, appId) {
  return request.post("/dingGroup/createDingGroup", dingGroup, { params: { appId } })
}
